import "../css/funds.css";
import { FaUsers, FaHeart, FaCalendarAlt } from "react-icons/fa";

export default function Funds() {
  return (
    <div className="funds">
      <div className="container">
        <div className="funds-row"> {/* Responsive Flex/Grid */}
          <div className="funds-item">
            <FaUsers className="funds-icon" />
            <div className="funds-text">
              <h3 className="facts-plus">3908</h3>
              <p>People Visited</p>
            </div>
          </div>
          <div className="funds-item">
            <FaHeart className="funds-icon" />
            <div className="funds-text">
              <h3 className="facts-plus">100</h3>
              <p>Family Supported</p>
            </div>
          </div>
          <div className="funds-item">
            <FaCalendarAlt className="funds-icon" />
            <div className="funds-text">
              <h3 className="facts-plus">3</h3>
              <p>Events Hosted</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
